/*
* AbstractPdfContent.js
* Created on 22-11-2017
* @author Olivier for &ranj
*/

import { isNull } from "../../../util/TypeUtil";

export default class AbstractPdfContent {
    constructor(style) {
        this._style = style || {};

        this._padding = [0, 0, 0, 0]; //CSS-like padding array, containing padding values in the following order: top, right, bottom, left

        //each class that implements AbstractPdfContent has their own logic for calculating the width and height
        this._width = 0;
        this._height = 0;

        this._border = 0;
        this._borderColor = [0, 0, 0];
        this._backgroundColor = null;

        this.parent = null;
    }

    setPropertiesFromObject(obj) {
        this._style = obj;

        for (var property in obj) {
            if (obj.hasOwnProperty(property)) {
                switch (property) {
                    case ("height"): this.setHeight(obj[property]); break;
                    case ("width"): this.setWidth(obj[property]); break;
                    case ("padding"): this.setPadding(obj[property]); break;
                    case ("border"): this.setBorder(obj[property]); break;
                    case ("borderColor"): this.setBorderColor(obj[property]); break;
                    case ("backgroundColor"): this.setBackgroundColor(obj[property]); break;
                }
            }
        }
    }

    getHeight() {
        return this._height;
    }

    getFullHeight() {
        return this._height + this._padding[0] + this._padding[2];
    }

    setHeight(value) {
        this._height = value;
    }

    getWidth() {
        return this._width;
    }

    getFullWidth() {
        return this._width + this._padding[1] + this._padding[3];
    }

    setWidth(value) {
        this._width = value;
    }

    getPadding() {
        return this._padding;
    }

    setPadding(padding) {
        switch (padding.length) {
            case (0): this._padding = [0, 0, 0, 0]; break;
            case (1): this._padding = [padding[0], padding[0], padding[0], padding[0]]; break;
            case (2): this._padding = [padding[0], padding[1], padding[0], padding[1]]; break;
            case (3): this._padding = [padding[0], padding[1], padding[2], padding[1]]; break;
            case (4): this._padding = padding; break;
        }
    }

    setBorder(size) {
        this._border = size;
    }

    setBorderColor(color) {
        this._borderColor = color;
    }

    setBackgroundColor(color) {
        this._backgroundColor = color;
    }

    calculateBounds(doc) { }; //override in child class to define width / height calculations if necessary

    //override in child class to define content drawing logic, but call this abstract function for border and background drawing
    printToDocument(doc, x, y) {
        const top = y;
        const left = x;

        if (!isNull(this._backgroundColor)) {
            //draw background
            doc.setLineWidth(1);
            doc.setDrawColor(this._backgroundColor[0], this._backgroundColor[1], this._backgroundColor[2]);
            doc.setFillColor(this._backgroundColor[0], this._backgroundColor[1], this._backgroundColor[2]);
            doc.rect(left + .5, top + .5, this._width - 1, this.getFullHeight() - 1, 'FD');
        }

        if (this._border > 0) {
            //draw border
            doc.setLineWidth(this._border - 0.5);
            doc.setDrawColor(this._borderColor[0], this._borderColor[1], this._borderColor[2]);
            doc.rect(left, top, this._width, this.getFullHeight());

            doc.setLineWidth(1);
        }
    }
}